import useUser from '@/hooks/useUser';
import { useMount } from '@simplywallst/ui-core';
import { useParams } from '@/hooks/location/useParams';
import { NarrativeUpdateEdit } from './components/NarrativeUpdateEdit';
import { NarrativeNotFound } from './components/NarrativeNotFound';

export const NarrativeUpdateEditPage = () => {
  const { companyid, updateid } = useParams<{
    companyid: string;
    updateid: string | undefined;
  }>();
  const { data: user } = useUser();

  useMount(() => window.scrollTo(0, 0));

  if (!companyid) return <NarrativeNotFound />;
  if (!user.loggedIn) {
    return null; // TODO Show skeleton and narrative modal
  }

  return (
    <NarrativeUpdateEdit
      companyId={companyid.toLowerCase()}
      updateId={updateid}
    />
  );
};
